<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgement</h1>
<p>I am grateful to Thomas Abonyo, ‘Chairman’ Phinias Sichongwe and Philip Snow for their excellent insights on China, and to the many friends I met who aided and challenged my understanding of the region.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?08a9ed76